import React from 'react';
const PipeRightAngle3Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="56.25" y1="56.2495" x2="0" y2="56.2495">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="56.2495" y1="56.25" x2="56.2495" y2="112.5005">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M56.25,0H0v112.5l56.25-15.35V0z" />
      <path fill={`url(#${id}_2)`} d="M112.5,56.25v56.25H0l56.25-56.25H112.5z" />
    </svg>
  );
};
export default PipeRightAngle3Icon;
